
class Config {
    static FLOATING_POINT_PRECISION = 6
    static FLOATING_POINT_PRECISION_FOR_SCALED_NUMBERS = 4
}

export default Config